import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "../core/Logger.js";
import { isNone as r } from "../core/maybe.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { cast as i } from "../core/accessorSupport/decorators/cast.js";
import { reader as o } from "../core/accessorSupport/decorators/reader.js";
import { subclass as a } from "../core/accessorSupport/decorators/subclass.js";
import { writer as n } from "../core/accessorSupport/decorators/writer.js";
import { ensureNumber as l } from "../core/accessorSupport/ensureType.js";
import c from "./Geometry.js";
import p from "./SpatialReference.js";
import { offsetPoint as u } from "./support/offset.js";
import { distance as h } from "./support/pointUtils.js";
import { getInfo as d } from "./support/spatialReferenceUtils.js";
import { lngLatToXY as m, xyToLngLat as y } from "./support/webMercatorUtils.js";

var _f;

var g = [0, 0];

function x(e) {
  return e && ("esri.geometry.SpatialReference" === e.declaredClass || null != e.wkid);
}

var w = t.getLogger("esri.geometry.Point");

var b = _f = /*#__PURE__*/function (_c) {
  _inherits(f, _c);

  var _super = _createSuper(f);

  function f() {
    var _this;

    _classCallCheck(this, f);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this.x = 0, _this.y = 0, _this.z = void 0, _this.m = void 0, _this.type = "point";
    return _this;
  }

  _createClass(f, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e, t, r, s, i) {
      var o;
      if (Array.isArray(e)) o = e, i = t, e = o[0], t = o[1], r = o[2], s = o[3];else if (e && "object" == typeof e) {
        if (o = e, e = null != o.x ? o.x : o.longitude, t = null != o.y ? o.y : o.latitude, r = o.z, s = o.m, (i = o.spatialReference) && "esri.geometry.SpatialReference" !== i.declaredClass && (i = new p(i)), null != o.longitude || null != o.latitude) if (null == o.longitude) w.warn(".longitude=", "Latitude was defined without longitude");else if (null == o.latitude) w.warn(".latitude=", "Longitude was defined without latitude");else if (!o.declaredClass && i && i.isWebMercator) {
          var _r = m(o.longitude, o.latitude, g);

          e = _r[0], t = _r[1];
        }
      } else x(r) ? (i = r, r = null) : x(s) && (i = s, s = null);
      var a = {
        x: e,
        y: t
      };
      return null == a.x && null != a.y ? w.warn(".y=", "Y coordinate was defined without an X coordinate") : null == a.y && null != a.x && w.warn(".x=", "X coordinate was defined without a Y coordinate"), null != i && (a.spatialReference = i), null != r && (a.z = r), null != s && (a.m = s), a;
    }
  }, {
    key: "cache",
    get: function get() {
      return this.commitProperty("x"), this.commitProperty("y"), this.commitProperty("z"), this.commitProperty("m"), this.commitProperty("spatialReference"), {};
    }
  }, {
    key: "hasM",
    get: function get() {
      return void 0 !== this.m;
    },
    set: function set(e) {
      e !== (void 0 !== this._get("m")) && (this._set("m", e ? 0 : void 0), this._set("hasM", e));
    }
  }, {
    key: "hasZ",
    get: function get() {
      return void 0 !== this.z;
    },
    set: function set(e) {
      e !== (void 0 !== this._get("z")) && (this._set("z", e ? 0 : void 0), this._set("hasZ", e));
    }
  }, {
    key: "latitude",
    get: function get() {
      var e = this.spatialReference,
          t = this.x,
          r = this.y;

      if (e) {
        if (e.isWebMercator) return y(t, r, g)[1];
        if (e.isGeographic) return r;
      }

      return null;
    },
    set: function set(e) {
      var t = this.spatialReference,
          r = this.x;
      t && (t.isWebMercator ? this._set("y", m(r, e, g)[1]) : t.isGeographic && this._set("y", e), this._set("latitude", e));
    }
  }, {
    key: "longitude",
    get: function get() {
      var e = this.x,
          t = this.y,
          r = this.spatialReference;

      if (r) {
        if (r.isWebMercator) return y(e, t, g)[0];
        if (r.isGeographic) return e;
      }

      return null;
    },
    set: function set(e) {
      var t = this.y,
          r = this.spatialReference;
      r && (r.isWebMercator ? this._set("x", m(e, t, g)[0]) : r.isGeographic && this._set("x", e), this._set("longitude", e));
    }
  }, {
    key: "writeX",
    value: function writeX(e, t, r) {
      t[r] = isNaN(e) ? "NaN" : e;
    }
  }, {
    key: "readX",
    value: function readX(e) {
      return "string" == typeof e ? NaN : e;
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = new _f();
      return e.x = this.x, e.y = this.y, e.z = this.z, e.m = this.m, e.spatialReference = this.spatialReference, e;
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return _f.copy(e, this), this;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      var _m, _m2;

      if (r(e)) return !1;
      var t = this.x,
          s = this.y,
          i = this.z,
          o = this.m,
          a = this.spatialReference,
          n = e.z,
          l = e.m;
      var c = e.x,
          p = e.y,
          u = e.spatialReference;
      if (!a.equals(u)) if (a.isWebMercator && u.isWGS84) (_m = m(c, p), _m2 = _slicedToArray(_m, 2), c = _m2[0], p = _m2[1], _m), u = a;else {
        var _y, _y2;

        if (!a.isWGS84 || !u.isWebMercator) return !1;
        (_y = y(c, p), _y2 = _slicedToArray(_y, 2), c = _y2[0], p = _y2[1], _y), u = a;
      }
      return t === c && s === p && i === n && o === l && a.wkid === u.wkid;
    }
  }, {
    key: "offset",
    value: function offset(e, t, r) {
      return u(this, e, t, r);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      if (!this.spatialReference) return this;
      var e = d(this.spatialReference);
      if (!e) return this;
      var t = this.x;

      var _e$valid = _slicedToArray(e.valid, 2),
          r = _e$valid[0],
          s = _e$valid[1],
          i = 2 * s;

      var o;
      return t > s ? (o = Math.ceil(Math.abs(t - s) / i), t -= o * i) : t < r && (o = Math.ceil(Math.abs(t - r) / i), t += o * i), this._set("x", t), this;
    }
  }, {
    key: "distance",
    value: function distance(e) {
      return h(this, e);
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var e = this.hasZ,
          t = this.hasM;
      return e && t ? [this.x, this.y, this.z, this.m] : e ? [this.x, this.y, this.z] : t ? [this.x, this.y, this.m] : [this.x, this.y];
    }
  }, {
    key: "toJSON",
    value: function toJSON(e) {
      return this.write({}, e);
    }
  }], [{
    key: "copy",
    value: function copy(e, t) {
      t._set("x", e._get("x")), t._set("y", e._get("y")), t._set("z", e._get("z")), t._set("m", e._get("m"));

      var r = e._get("spatialReference");

      t._set("spatialReference", Object.isFrozen(r) ? r : r.clone());
    }
  }]);

  return f;
}(c);

e([s({
  readOnly: !0
})], b.prototype, "cache", null), e([s({
  type: Boolean,
  json: {
    read: !1,
    write: {
      enabled: !1,
      overridePolicy: null
    }
  }
})], b.prototype, "hasM", null), e([s({
  type: Boolean,
  json: {
    read: !1,
    write: {
      enabled: !1,
      overridePolicy: null
    }
  }
})], b.prototype, "hasZ", null), e([s({
  type: Number
})], b.prototype, "latitude", null), e([s({
  type: Number
})], b.prototype, "longitude", null), e([s({
  type: Number,
  json: {
    type: [Number, String],
    write: {
      isRequired: !0,
      allowNull: !0
    }
  }
}), i(function (e) {
  return isNaN(e) ? e : l(e);
})], b.prototype, "x", void 0), e([n("x")], b.prototype, "writeX", null), e([o("x")], b.prototype, "readX", null), e([s({
  type: Number,
  json: {
    write: !0
  }
})], b.prototype, "y", void 0), e([s({
  type: Number,
  json: {
    write: {
      overridePolicy: function overridePolicy() {
        return {
          enabled: this.hasZ
        };
      }
    }
  }
})], b.prototype, "z", void 0), e([s({
  type: Number,
  json: {
    write: {
      overridePolicy: function overridePolicy() {
        return {
          enabled: this.hasM
        };
      }
    }
  }
})], b.prototype, "m", void 0), b = _f = e([a("esri.geometry.Point")], b), b.prototype.toJSON.isDefaultToJSON = !0;
var j = b;
export { j as default };